import { Injectable } from '@angular/core';
import { ManagementPageSessionStorageService } from '../shared/management-page-session-storage.service';
import type { GroupsModalSessionState, GroupsPageSessionState } from '../../presentations/models/groups-management.model';

@Injectable({ providedIn: 'root' })
export class GroupsManagementModalSessionService {
  private readonly modalStorageKey = 'smatchy:bo:groups-management:modal-state';
  private readonly pageStorageKey = 'smatchy:bo:groups-management:page-state';

  constructor(private storage: ManagementPageSessionStorageService) {}

  read(): GroupsModalSessionState | null {
    return this.storage.read<GroupsModalSessionState>(this.modalStorageKey);
  }

  save(state: GroupsModalSessionState) {
    this.storage.save(this.modalStorageKey, state);
  }

  clear() {
    this.storage.clear(this.modalStorageKey);
  }

  readPageState(): GroupsPageSessionState | null {
    return this.storage.read<GroupsPageSessionState>(this.pageStorageKey);
  }

  savePageState(state: GroupsPageSessionState) {
    this.storage.save(this.pageStorageKey, state);
  }

  clearPageState() {
    this.storage.clear(this.pageStorageKey);
  }
}
